import React, { useState } from 'react';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Ui from './Ui';
import Caching from './Caching';
import Tools from './Tools';
import HistoryCache from './HistoryCache';

function Developer() {
  const [view, setView] = useState('tools'); // ui, tools, caching, history

  return (
    <div>
      <AppBar position="static">
        <Tabs value={view} onChange={(ev, val) => setView(val)} className="container">
          <Tab label="Ui" value="ui" />
          <Tab label="Tools" value="tools" />
          <Tab label="Caching" value="caching" />
          <Tab label="History" value="history" />
        </Tabs>
      </AppBar>
      {view === 'ui' && <Ui />}
      {view === 'tools' && <Tools />}
      {view === 'caching' && <Caching />}
      {view === 'history' && <HistoryCache />}
    </div>
  );
}

export default Developer;